import React, {useState} from "react";
import "./review.css";
import Review from "./Component/review"
function Reviews() {
  const [openr, seTr] = useState(false);
  return (
    <div className="review-container">
      {/* HERO SECTION */}
      <div className="chitto">
        <div className="banner-contact">
          <img src="/img/company/review.jpg" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>What Our Travelers Say</h1>
        <p>Real experiences from real people</p>
        <div className="sticky-contain" onClick={() => seTr(true)}>
                  <p className="sticky-contain-p">(Write Review)</p>
                </div>
      </div>
      </div>
      </div>
      {openr &&( 
  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review/></section>
  
)}
      {/* REVIEW GRID */}
      <div className="review-grid">
        {/* REVIEW 1 */}
        <div className="review-card">
          <div className="review-top">
            <img src="/img/capital/myself.jpg" alt="user" />
            <div>
              <h3>Alexander</h3>
              <div className="review-stars">★★★★★</div>
            </div>
          </div>
          <p>
          had a great private tour today with Bishnu at Swayambhunath Stupa in Kathmandu. What made the experience special was not only the place itself, but the way Bishnu guided the tour.

He is very knowledgeable, easy to talk to, and explains the history, culture and religious meaning in a very engaging and natural way. The tour never felt rushed or overly “touristic” — more like exploring the place with someone who genuinely loves and understands it.

              {"\n\n"}
              I especially appreciated how flexible and attentive he was throughout the tour, answering all my questions and sharing many interesting details I would never notice on my own.

Highly recommend Bishnu if you want a thoughtful and authentic experience in Kathmandu.
          </p>
        </div>
        <div className="review-card">
          <div className="review-top">
            <img src="/img/company/airportdslr.jpeg" alt="user" />
            <div>
              <h3>Rahul Sharma</h3>
              <div className="review-stars">★★★★★</div>
            </div>
          </div>
          <p>
            Amazing experience! Everything was perfectly managed. Highly
            recommended for Nepal tours.
          </p>
        </div>

        {/* REVIEW 2 */}
        <div className="review-card">
          <div className="review-top">
            <img src="/img/company/groupphoto.jpeg" alt="user" />
            <div>
              <h3>Sophia Lee</h3>
              <div className="review-stars">★★★★★</div>
            </div>
          </div>
          <p>
            The guide was very professional and friendly. Loved every moment of
            the trip!
          </p>
        </div>

        {/* REVIEW 3 */}
        <div className="review-card">
          <div className="review-top">
            <img src="/img/capital/holi1dslr.jpeg" alt="user" />
            <div>
              <h3>David Miller</h3>
              <div className="review-stars">★★★★☆</div>
            </div>
          </div>
          <p>
            Great service and smooth booking process. Will definitely travel
            again with them.
          </p>
        </div>

        {/* REVIEW 4 */}
        <div className="review-card">
          <div className="review-top">
            <img src="/img/treek/dhampusht.jpeg" alt="user" />
            <div>
              <h3>Anita Verma</h3>
              <div className="review-stars">★★★★★</div>
            </div>
          </div>
          <p>
            Best travel company I’ve experienced so far. Everything was seamless.
          </p>
        </div>

        {/* REVIEW 5 */}
        <div className="review-card">
          <div className="review-top">
            <img src="/img/chitwan/chitwan3dslr.jpeg" alt="user" />
            <div>
              <h3>John Carter</h3>
              <div className="review-stars">★★★★☆</div>
            </div>
          </div>
          <p>
            Very good experience overall. Customer support was excellent.
          </p>
        </div>

        {/* REVIEW 6 */}
      </div>
    </div>
  );
}

export default Reviews;